function parseBaseUrl() {
     
    const host = window.location.host;
    if (host.startsWith("localhost")) {
        return "https://localhost:44386/";
    } else {
        let arr = window.location.host.split(".");
        if (host.endsWith("azurewebsites.net")) {
            arr[0] = arr[0] + "-api";
        } else {
            arr[0] = "api-" + arr[0];
        }
        
        return `${window.location.protocol}//${arr.join(".")}/`;
    }
}

export const BASE_API_URL = parseBaseUrl();
export const BASE_CDN = "https://xeonstorage.blob.core.windows.net/erp/";

export const LOGIN = "api/authorization";
export const LOGOUT = "api/authorization/logout";
export const REFRESH_TOKEN = "api/authorization/refresh";

export const ACCOUNTS = "api/accounts";
export const JOURNALS = "api/journals"; 
export const PRODUCTS = "api/Products";
export const CATEGORIES = "api/Categories";
export const PRODUCTS_BATCHES = "api/ProductBatches";
export const DISCOUNTS = "api/Discounts";
export const SALES_INVOICE = "api/SalesInvoices";
export const USER = "api/Users";
export const CONTACTS = "api/Contacts";
export const ROLE = "api/Roles";

export const MY_ROLE = "api/Users/my/roles";
export const VALIDATE_MY_ROLE = "/api/Users/validate/my/role";

export const CHALLAN_INVOICE_REPORT = "report/challan-invoice";
export const SALES_INVOICE_REPORT = "report/sales-invoice";
export const STOCK_TRANSFER_REPORT = "report/stock-transfer";
export const REPORT_CASH_RECEPIT = "report/cash-invoice";
export const ACCOUNTING_REPORT = "report/accounting";
export const ACCOUNT_LOG = "api/AccountLogs";
export const SALES_INVOICE_LOG = "api/SalesInvoiceLogs";
export const JOURNAL_LOG = "api/JournalLogs";
export const USER_LOG = "api/UserLogs";
export const ATTACHMENT = "api/Attachments";
export const PRODUCTS_SALES_HISTORY = "api/ProductSalesReports";
export const EMPLOYEE = "api/Employees";
export const EMPLOYEE_ROLE = "api/EmployeeRoles";
export const SALES_DATE = "api/SalesData";
export const DISTRIBUTOR_STOCK = "/api/DistributorsMonthlyStocks";
export const EMPLOYEE_REGION = "/api/Regions";
export const EMPLOYEE_TERRITORY = "/api/RegionTerritories";
export const EMPLOYEE_LOCATION = "/api/DistributorLocations";
export const EMPLOYEE_ROUTE = "/api/LocationRoutes";
export const CHALLAN_INVOICE = "/api/ChallanInvoices";
export const STOCK = "/api/Stock";
export const ORG_UNIT = "/api/OrgUnits";
export const STOCK_ITEMS = "/api/StockItems";
export const BANK_CHEQUE = "/api/BankCheques";
export const UPDATE_BANK_CHEQUE_STATUS = "/api/BankCheques/chequeStatusUpdate";
export const CONFIGURATION = "api/configurations";
export const CLIENT_MODULES = "api/clientModules";
export const PURCHASE_INVOICE = "api/purchaseInvoices";




// WEBPACK FOOTER //
// ./src/common/ApiUrls.js